/**
 * Sélecteur de période Analytics — contrat unique 7j / 30j / 90j / 1a / Personnalisé.
 * Dates personnalisées : auto-appliquées dès que début + fin sont renseignés (pas de bouton Appliquer).
 */

export const ANALYTICS_PERIOD_PRESETS = ['7j', '30j', '90j', '1a'];

const PRESET_LABELS = {
  '7j': '7 jours',
  '30j': '30 jours',
  '90j': '90 jours',
  '1a': '1 an',
};

/**
 * @param {'blue'|'primary'} tone
 */
export default function AnalyticsPeriodSelector({
  periode,
  onPeriodChange,
  customDateDebut = '',
  customDateFin = '',
  onCustomDebutChange,
  onCustomFinChange,
  tone = 'blue',
  className = '',
  testId = 'analytics-period-selector',
}) {
  const active =
    tone === 'primary'
      ? 'bg-primary-100 text-primary-700'
      : 'bg-blue-600 text-white';
  const idle =
    tone === 'primary'
      ? 'text-gray-600 hover:text-gray-900'
      : 'bg-gray-100 text-gray-700 hover:bg-gray-200';
  const inputCls =
    tone === 'primary'
      ? 'border border-gray-300 rounded-lg px-2 py-1'
      : 'border border-gray-300 rounded-md px-2 py-1';

  return (
    <div className={`flex flex-col items-end gap-2 ${className}`} data-testid={testId}>
      <div className="flex flex-wrap items-center gap-2 justify-end">
        {ANALYTICS_PERIOD_PRESETS.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onPeriodChange?.(p)}
            className={`px-3 py-1 rounded-md text-sm font-medium ${
              periode === p ? active : idle
            }`}
            data-testid={`analytics-period-${p}`}
          >
            {PRESET_LABELS[p] || p}
          </button>
        ))}
        <button
          type="button"
          onClick={() => onPeriodChange?.('custom')}
          className={`px-3 py-1 rounded-md text-sm font-medium ${
            periode === 'custom' ? active : idle
          }`}
          data-testid="analytics-period-custom"
        >
          Personnalisé
        </button>
      </div>
      {periode === 'custom' ? (
        <div className="flex flex-wrap items-center gap-2 text-sm justify-end">
          <input
            type="date"
            value={customDateDebut}
            onChange={(e) => onCustomDebutChange?.(e.target.value)}
            className={inputCls}
            aria-label="Date de début"
          />
          <span className="text-gray-500">→</span>
          <input
            type="date"
            value={customDateFin}
            onChange={(e) => onCustomFinChange?.(e.target.value)}
            className={inputCls}
            aria-label="Date de fin"
          />
          {customDateDebut && customDateFin ? (
            <span className="text-[11px] text-gray-500">Mise à jour automatique</span>
          ) : (
            <span className="text-[11px] text-amber-700">Choisissez début et fin</span>
          )}
        </div>
      ) : null}
    </div>
  );
}
